"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListUserInvitationsStatus = exports.CreateUserAssetOperationType = exports.UsersApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class UsersApi extends runtime.BaseAPI {
    /**
     * Activate a user
     * Activate User
     */
    activateRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling activate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/activate`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Activate a user
     * Activate User
     */
    activate(userSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.activateRaw({ userSid: userSid });
        });
    }
    /**
     * Creates users from CSV
     * Batch Create User
     */
    batchCreateUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/~batch`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiBatchCreateUserRequestToJSON)(requestParameters.streemApiBatchCreateUserRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiBatchCreateUserResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Creates users from CSV
     * Batch Create User
     */
    batchCreateUser(streemApiBatchCreateUserRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.batchCreateUserRaw({ streemApiBatchCreateUserRequest: streemApiBatchCreateUserRequest });
            return yield response.value();
        });
    }
    /**
     * Deactivates users from CSV
     * Batch Deactivate User
     */
    batchDeactivateUsersRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/~batch/deactivate`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiBatchDeactivateUserRequestToJSON)(requestParameters.streemApiBatchDeactivateUserRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deactivates users from CSV
     * Batch Deactivate User
     */
    batchDeactivateUsers(streemApiBatchDeactivateUserRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.batchDeactivateUsersRaw({ streemApiBatchDeactivateUserRequest: streemApiBatchDeactivateUserRequest });
        });
    }
    /**
     * Create a user for log-in for this Company
     * Create a user
     */
    createCompanyUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createCompanyUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/users`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateCompanyUserRequestToJSON)(requestParameters.streemApiCreateCompanyUserRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateCompanyUserResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a user for log-in for this Company
     * Create a user
     */
    createCompanyUser(companyCodeOrSid, streemApiCreateCompanyUserRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createCompanyUserRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreateCompanyUserRequest: streemApiCreateCompanyUserRequest });
            return yield response.value();
        });
    }
    /**
     * Upload a user asset
     */
    createUserAssetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling createUserAsset.');
            }
            if (requestParameters.type === null || requestParameters.type === undefined) {
                throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling createUserAsset.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/assets/{type}`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))).replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemInternalApiCreateUserAssetRequestToJSON)(requestParameters.streemInternalApiCreateUserAssetRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateUserAssetResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Upload a user asset
     */
    createUserAsset(userSid, type, streemInternalApiCreateUserAssetRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createUserAssetRaw({ userSid: userSid, type: type, streemInternalApiCreateUserAssetRequest: streemInternalApiCreateUserAssetRequest });
            return yield response.value();
        });
    }
    /**
     * Creates a token for accessing a user wall
     * Create Token
     */
    createUserTokensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling createUserTokens.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/tokens`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateUserTokensResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Creates a token for accessing a user wall
     * Create Token
     */
    createUserTokens(userSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createUserTokensRaw({ userSid: userSid });
            return yield response.value();
        });
    }
    /**
     * Save VoIP token for the specified user
     * Save VOIP Token
     */
    createUserVoipTokenRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling createUserVoipToken.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/voip-tokens`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateUserVoipTokenRequestToJSON)(requestParameters.streemApiCreateUserVoipTokenRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Save VoIP token for the specified user
     * Save VOIP Token
     */
    createUserVoipToken(userSid, streemApiCreateUserVoipTokenRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.createUserVoipTokenRaw({ userSid: userSid, streemApiCreateUserVoipTokenRequest: streemApiCreateUserVoipTokenRequest });
        });
    }
    /**
     * Deactivate a user
     * Deactivate User
     */
    deactivateRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling deactivate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/deactivate`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deactivate a user
     * Deactivate User
     */
    deactivate(userSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deactivateRaw({ userSid: userSid });
        });
    }
    /**
     * Delete the specified user
     * Delete User
     */
    deleteUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling deleteUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete the specified user
     * Delete User
     */
    deleteUser(userSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteUserRaw({ userSid: userSid });
        });
    }
    /**
     * Get all companies associated with the requesting user; currently their membership is associated by email
     * Get companies associated with a user
     */
    getAssociatedCompaniesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling getAssociatedCompanies.');
            }
            const queryParameters = {};
            if (requestParameters.switchWorkspacesEnabled !== undefined) {
                queryParameters['switch_workspaces_enabled'] = requestParameters.switchWorkspacesEnabled;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/associated-companies`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetAssociatedCompaniesResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get all companies associated with the requesting user; currently their membership is associated by email
     * Get companies associated with a user
     */
    getAssociatedCompanies(userSid, switchWorkspacesEnabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAssociatedCompaniesRaw({ userSid: userSid, switchWorkspacesEnabled: switchWorkspacesEnabled });
            return yield response.value();
        });
    }
    /**
     */
    getLoginIdentityCompaniesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling getLoginIdentityCompanies.');
            }
            const queryParameters = {};
            if (requestParameters.switchWorkspacesEnabled !== undefined) {
                queryParameters['switch_workspaces_enabled'] = requestParameters.switchWorkspacesEnabled;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/login-identity-companies`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemInternalApiGlobalGetUserLoginIdentityCompaniesResponseFromJSON)(jsonValue));
        });
    }
    /**
     */
    getLoginIdentityCompanies(userSid, switchWorkspacesEnabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getLoginIdentityCompaniesRaw({ userSid: userSid, switchWorkspacesEnabled: switchWorkspacesEnabled });
            return yield response.value();
        });
    }
    /**
     * Returns true if the user should see the Streem survey.
     * Get Streem Survey Status
     */
    getStreemSurveyStatusRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling getStreemSurveyStatus.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/streem-survey-status`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetStreemSurveyStatusResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Returns true if the user should see the Streem survey.
     * Get Streem Survey Status
     */
    getStreemSurveyStatus(userSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStreemSurveyStatusRaw({ userSid: userSid });
            return yield response.value();
        });
    }
    /**
     * Get user by user sid
     * Get User
     */
    getUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling getUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetUserResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get user by user sid
     * Get User
     */
    getUser(userSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUserRaw({ userSid: userSid });
            return yield response.value();
        });
    }
    /**
     * Returns the current Availability Status for the user.  (Only supported if User Availability is enabled)
     * Get User Availability
     */
    getUserAvailabilityRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling getUserAvailability.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/availability`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetUserAvailabilityResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Returns the current Availability Status for the user.  (Only supported if User Availability is enabled)
     * Get User Availability
     */
    getUserAvailability(userSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUserAvailabilityRaw({ userSid: userSid });
            return yield response.value();
        });
    }
    /**
     * Get User by `external_user_id`, which should be unique in the scope of the specified Company
     * Get User By External User Id
     */
    getUserByExternalUserIdRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getUserByExternalUserId.');
            }
            if (requestParameters.externalUserId === null || requestParameters.externalUserId === undefined) {
                throw new runtime.RequiredError('externalUserId', 'Required parameter requestParameters.externalUserId was null or undefined when calling getUserByExternalUserId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/users/{external_user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"external_user_id"}}`, encodeURIComponent(String(requestParameters.externalUserId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetUserByExternalUserIdResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get User by `external_user_id`, which should be unique in the scope of the specified Company
     * Get User By External User Id
     */
    getUserByExternalUserId(companyCodeOrSid, externalUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUserByExternalUserIdRaw({ companyCodeOrSid: companyCodeOrSid, externalUserId: externalUserId });
            return yield response.value();
        });
    }
    /**
     * Get list of call log entries for user
     * Get Call Log
     */
    getUserCallLogRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling getUserCallLog.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            if (requestParameters.filter !== undefined) {
                queryParameters['filter'] = requestParameters.filter;
            }
            if (requestParameters.favoritesOnly !== undefined) {
                queryParameters['favorites_only'] = requestParameters.favoritesOnly;
            }
            if (requestParameters.callSourceCodes) {
                queryParameters['call_source_codes'] = requestParameters.callSourceCodes;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/call-log`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetUserCallLogResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get list of call log entries for user
     * Get Call Log
     */
    getUserCallLog(userSid, pageSize, pageToken, filter, favoritesOnly, callSourceCodes) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUserCallLogRaw({ userSid: userSid, pageSize: pageSize, pageToken: pageToken, filter: filter, favoritesOnly: favoritesOnly, callSourceCodes: callSourceCodes });
            return yield response.value();
        });
    }
    /**
     * Get single call log entry for room
     * Get Call Log Entry
     */
    getUserCallLogEntryRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling getUserCallLogEntry.');
            }
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getUserCallLogEntry.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/call-log/{room_sid}`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))).replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetUserCallLogEntryResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get single call log entry for room
     * Get Call Log Entry
     */
    getUserCallLogEntry(userSid, roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUserCallLogEntryRaw({ userSid: userSid, roomSid: roomSid });
            return yield response.value();
        });
    }
    /**
     * Returns false if the user has not accepted terms yet, false if the user has accepted but the termhave changed, and true if the user has accepted the most recent terms
     * Get User Terms Status
     */
    getUserTermsStatusRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling getUserTermsStatus.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/terms-status`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetUserTermsStatusResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Returns false if the user has not accepted terms yet, false if the user has accepted but the termhave changed, and true if the user has accepted the most recent terms
     * Get User Terms Status
     */
    getUserTermsStatus(userSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUserTermsStatusRaw({ userSid: userSid });
            return yield response.value();
        });
    }
    /**
     * Identify as the specified user
     * Identify User
     */
    identifyUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling identifyUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiIdentifyUserRequestToJSON)(requestParameters.streemApiIdentifyUserRequest),
            });
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Identify as the specified user
     * Identify User
     */
    identifyUser(userSid, streemApiIdentifyUserRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.identifyUserRaw({ userSid: userSid, streemApiIdentifyUserRequest: streemApiIdentifyUserRequest });
            return yield response.value();
        });
    }
    /**
     * Get all Devices for specified User
     * List Devices
     */
    listDevicesForUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling listDevicesForUser.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/devices`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListUserDevicesResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get all Devices for specified User
     * List Devices
     */
    listDevicesForUser(userSid, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listDevicesForUserRaw({ userSid: userSid, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * Get list of users that have logged in recently
     * Get Recent Users
     */
    listRecentlyIdentifiedUsersRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.isExpert !== undefined) {
                queryParameters['is_expert'] = requestParameters.isExpert;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/recently-identified`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListRecentlyIdentifiedUsersResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get list of users that have logged in recently
     * Get Recent Users
     */
    listRecentlyIdentifiedUsers(isExpert, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listRecentlyIdentifiedUsersRaw({ isExpert: isExpert, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * Get invitations for this user, optionally filtering on device and status
     * Get Invitations
     */
    listUserInvitationsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling listUserInvitations.');
            }
            const queryParameters = {};
            if (requestParameters.deviceSid !== undefined) {
                queryParameters['device_sid'] = requestParameters.deviceSid;
            }
            if (requestParameters.status !== undefined) {
                queryParameters['status'] = requestParameters.status;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/invitations`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListUserInvitationsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get invitations for this user, optionally filtering on device and status
     * Get Invitations
     */
    listUserInvitations(userSid, deviceSid, status, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listUserInvitationsRaw({ userSid: userSid, deviceSid: deviceSid, status: status, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * Updates the user\'s last view of the Streem survey to the current date and time.
     * Save Streem Survey Status
     */
    saveStreemSurveyStatusRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling saveStreemSurveyStatus.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/streem-survey-status`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Updates the user\'s last view of the Streem survey to the current date and time.
     * Save Streem Survey Status
     */
    saveStreemSurveyStatus(userSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.saveStreemSurveyStatusRaw({ userSid: userSid });
        });
    }
    /**
     * Updates the day the user accepted the terms and conditions to the current date and time
     * Save User Terms Status
     */
    saveUserTermsStatusRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling saveUserTermsStatus.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/terms-status`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiSaveUserTermsStatusRequestToJSON)(requestParameters.streemApiSaveUserTermsStatusRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiSaveUserTermsStatusResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Updates the day the user accepted the terms and conditions to the current date and time
     * Save User Terms Status
     */
    saveUserTermsStatus(userSid, streemApiSaveUserTermsStatusRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveUserTermsStatusRaw({ userSid: userSid, streemApiSaveUserTermsStatusRequest: streemApiSaveUserTermsStatusRequest });
            return yield response.value();
        });
    }
    /**
     * Update the groups a user belongs to
     * Update groups for user
     */
    updateGroupsForUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling updateGroupsForUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/groups`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiUpdateGroupsForUserRequestToJSON)(requestParameters.streemApiUpdateGroupsForUserRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiUpdateGroupsForUserResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update the groups a user belongs to
     * Update groups for user
     */
    updateGroupsForUser(userSid, streemApiUpdateGroupsForUserRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateGroupsForUserRaw({ userSid: userSid, streemApiUpdateGroupsForUserRequest: streemApiUpdateGroupsForUserRequest });
            return yield response.value();
        });
    }
    /**
     * Update the user
     * Update user
     */
    updateUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling updateUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiUpdateUserRequestToJSON)(requestParameters.streemApiUpdateUserRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiUpdateUserResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update the user
     * Update user
     */
    updateUser(userSid, streemApiUpdateUserRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateUserRaw({ userSid: userSid, streemApiUpdateUserRequest: streemApiUpdateUserRequest });
            return yield response.value();
        });
    }
    /**
     * Updates the availability status of a user (Only supported if User Availability is enabled)
     * Update User Availability
     */
    updateUserAvailabilityRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling updateUserAvailability.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/availability`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiUpdateUserAvailabilityRequestToJSON)(requestParameters.streemApiUpdateUserAvailabilityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiUpdateUserAvailabilityResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Updates the availability status of a user (Only supported if User Availability is enabled)
     * Update User Availability
     */
    updateUserAvailability(userSid, streemApiUpdateUserAvailabilityRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateUserAvailabilityRaw({ userSid: userSid, streemApiUpdateUserAvailabilityRequest: streemApiUpdateUserAvailabilityRequest });
            return yield response.value();
        });
    }
    /**
     * Update a call log entry for a room
     * Update Call Log Entry
     */
    updateUserCallLogEntryRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling updateUserCallLogEntry.');
            }
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling updateUserCallLogEntry.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/users/{user_sid}/call-log/{room_sid}`.replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))).replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiUpdateUserCallLogEntryRequestToJSON)(requestParameters.streemApiUpdateUserCallLogEntryRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiUpdateUserCallLogEntryResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update a call log entry for a room
     * Update Call Log Entry
     */
    updateUserCallLogEntry(userSid, roomSid, streemApiUpdateUserCallLogEntryRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateUserCallLogEntryRaw({ userSid: userSid, roomSid: roomSid, streemApiUpdateUserCallLogEntryRequest: streemApiUpdateUserCallLogEntryRequest });
            return yield response.value();
        });
    }
}
exports.UsersApi = UsersApi;
/**
    * @export
    * @enum {string}
    */
var CreateUserAssetOperationType;
(function (CreateUserAssetOperationType) {
    CreateUserAssetOperationType["AVATAR"] = "USER_UPLOAD_TYPE_AVATAR";
    CreateUserAssetOperationType["INVALID"] = "USER_UPLOAD_TYPE_INVALID";
})(CreateUserAssetOperationType = exports.CreateUserAssetOperationType || (exports.CreateUserAssetOperationType = {}));
/**
    * @export
    * @enum {string}
    */
var ListUserInvitationsStatus;
(function (ListUserInvitationsStatus) {
    ListUserInvitationsStatus["PENDING"] = "STATUS_PENDING";
    ListUserInvitationsStatus["ACCEPTED"] = "STATUS_ACCEPTED";
    ListUserInvitationsStatus["REJECTED"] = "STATUS_REJECTED";
    ListUserInvitationsStatus["CANCELED"] = "STATUS_CANCELED";
    ListUserInvitationsStatus["TIMEDOUT"] = "STATUS_TIMED_OUT";
    ListUserInvitationsStatus["INVALID"] = "STATUS_INVALID";
})(ListUserInvitationsStatus = exports.ListUserInvitationsStatus || (exports.ListUserInvitationsStatus = {}));
//# sourceMappingURL=UsersApi.js.map